import RoomInfoRequest from '../../../../../project-manager/files/i-services/models/request/RoomInfoRequest';

/**
 * * Модель запроса на завершение загрузки файла
 */
export default class CompleteAddFileRequest  {
	/**
	 * * Номер загрузки
	 */
	UploadId!: string;
	/**
	 * * Номер файла
	 */
	FileId!: number;
	/**
	 * * Название комнаты
	 */
	Room!: RoomInfoRequest;
	constructor(obj?: Partial<CompleteAddFileRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
